// extracted by mini-css-extract-plugin
export var main = "app-module--main--8fbdc";